import React from 'react'
import { NewBadge } from './NewBadge'
import { AttributionScopedItem } from './attributionScope/AttributionScopedItem'
import { NameWithSeenTooltip } from '../tooltips/NameWithSeenTooltip'
import { Box, Button, ListGrid, Link } from '@maui/elements'

export const ListItemLink = ({ children, to }) => (
  <Link
    href={to}
    display='flex'
    gap='8px'
    color='colorTextMain'
    alignItems="center"
  >
    {children}
  </Link>
)

export const ListItem = ({ children }) => (
  <Box
    variant='body1'
    textOverflow='ellipsis'
    whiteSpace='wrap'
    overflow='hidden'
  >
    {children}
  </Box>
)

export const NameWithSeenTooltipIcon = ({ iconName, flagProps = {}, item, iconComponent, type = '' }) => (
  <NameWithSeenTooltip
    Icon={iconComponent}
    iconName={iconName}
    flagProps={flagProps}
    name={item.name}
    lastSeen={item.last_seen}
    firstSeen={item.first_seen}
    type={type}
  />
)

export const IconListGrid = ({
  list,
  showItems,
  setShowItems,
  displayLimit,
  cellWidths,
  emptyMessage = 'No Data Available',
  renderItem = () => 'none',
}) => (
  <>
    <ListGrid
      list={showItems || list.length < displayLimit ? list : list.slice(0, displayLimit)}
      cellWidth={cellWidths}
      emptyMessage={emptyMessage}
    >
      {item => {
        const { attribution_scope: itemScope } = item
        return (
          <Box display='flex' alignItems='center'>
            {(itemScope)
              ? (
                <AttributionScopedItem itemScope={item.attribution_scope}>
                  { renderItem(item) }
                </AttributionScopedItem>
                )
              : renderItem(item)
            }
            <NewBadge
              date={item.last_seen ? item.last_seen : item.first_seen}
              color="colorOtherFreemiumLock"
              tooltip="New in the last month"
            />
          </Box>
        )
      }}
    </ListGrid>
    {list.length > displayLimit && (
      <Button
        onClick={() => setShowItems(!showItems)}
        variant="text"
        p="0"
      >
        {!showItems ? 'Show More' : 'Show Less'}
      </Button>
    )}
  </>
)
